import { NgModule } from '@angular/core'
import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { DisclaimerModalComponent } from './disclaimer-modal.component'

@NgModule({
  declarations: [
    DisclaimerModalComponent
  ],
  imports: [
    CmsComponentsBaseModule
  ],
  exports: [
    DisclaimerModalComponent
  ]
})
export class DisclaimerModalModule {
}

